<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
    {{message}}
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-flat-button color="primary" (click)="close()">Schliessen</button>
</mat-dialog-actions>
